const criticalFacilityInitialState = {
 affordableAndPublicHousing: null,
 communityCenters: null,
 correctionalFacilities: null,
 disasterRecoveryCenters: null,
 electricProdAndSupplyFacilities: null,
 fireStations: null,
 healthCareFacilities: null,
 hospitals: null,
 hurricaneDebrisStagingSites: null,
 lawEnforcementFacilities: null,
 localGovernmentFacilities: null,
 militaryParcels: null,
 schools: null,
 schoolsAsShelters: null,
 solidWasteAndWastewaterFacilities: null,
};

const criticalFacilityToggleState = {
 affordableAndPublicHousing: false,
 communityCenters: false,
 correctionalFacilities: false,
 disasterRecoveryCenters: false,
 electricProdAndSupplyFacilities: false,
 fireStations: false,
 healthCareFacilities: false,
 hospitals: false,
 hurricaneDebrisStagingSites: false,
 lawEnforcementFacilities: false,
 localGovernmentFacilities: false,
 militaryParcels: false,
 schools: false,
 schoolsAsShelters: false,
 solidWasteAndWastewaterFacilities: false,
};

module.exports = {
 criticalFacilityInitialState,
 criticalFacilityToggleState,
};
